import { useState } from "react"

import useRouter from "@hooks/useRouter"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { faIcon } from "@utils/faIcon"
import generateRandomKey from "@utils/generateRandomKey"

import { LinkButton } from "@atoms"
import { checkIfShouldActiveLink } from "@atoms/NavigationLink/NavigationLink"

import { Select } from "@molecules"
import type { SelectListItem } from "@molecules/Select/SelectListItem/SelectListItem.types"

import { HOME_ROUTE } from "@routes/home"

import styles from "./TopBarPageTitle.module.scss"
import { TopBarPageTitleProps } from "./TopBarPageTitle.types"

export default function TopBarPageTitle(props: TopBarPageTitleProps) {
    const { label, icon, navigationItems, onNavigationItemSelect } = props

    const [dropdownIsOpen, setDropdownIsOpen] = useState<boolean>(false)

    const hasSubItems = navigationItems && navigationItems.length > 0

    const onSelect = (item: SelectListItem) => {
        onNavigationItemSelect?.(item)
    }

    const router = useRouter()

    const [rootPath] = useSlugExtractor([HOME_ROUTE])

    return (
        <div className={styles.base}>
            {!hasSubItems ? (
                <LinkButton colorScheme="gray" leftIcon={icon} onClick={() => {}} noDebounce={true}>
                    {label}
                </LinkButton>
            ) : (
                <Select.Root isOpen={dropdownIsOpen} onOpenChange={setDropdownIsOpen}>
                    <Select.Trigger>
                        <LinkButton
                            colorScheme="gray"
                            leftIcon={icon}
                            rightIcon={faIcon({ name: "angles-up-down", style: "regular" })}
                            noDebounce={true}
                            onClick={() => {}}
                            isPressed={dropdownIsOpen}
                        >
                            {label}
                        </LinkButton>
                    </Select.Trigger>
                    <Select.Viewport>
                        <Select.List title={label} className={styles.list}>
                            <Select.ListGroup>
                                {navigationItems?.map((item) => {
                                    return (
                                        <Select.ListItem
                                            key={generateRandomKey()}
                                            variant={item.leading ? "icon" : "default"}
                                            item={item}
                                            isSelected={
                                                item.isActive ??
                                                checkIfShouldActiveLink(item.value, router.pathname, rootPath)
                                            }
                                            onSelect={() => onSelect(item)}
                                        />
                                    )
                                })}
                            </Select.ListGroup>
                        </Select.List>
                    </Select.Viewport>
                </Select.Root>
            )}
        </div>
    )
}
